import React from 'react'
import styled from 'styled-components'
//import logo from '../../assets/home/sidebar/white_logo.png'
import logo from '../../res/login/white_logo1.png'
import { v } from '../../styles/Variables'
import { AiOutlineLeft, AiOutlineHome } from "react-icons/ai"
import { FaMapMarkedAlt, FaSun, FaMoon, FaSignOutAlt } from "react-icons/fa"
import { BsFillDeviceSsdFill } from "react-icons/bs"
import { useNavigate, useLocation } from "react-router-dom"

function Sidebar({
  sideBarOpen,
  setSideBarOpen,
  theme,
  setTheme
}) {
  const navigate = useNavigate()
  const location = useLocation()

  const modSideBarOpen = () => {
    setSideBarOpen(!sideBarOpen)
  }

  const getActiveLabel = () => {
    const path = location.pathname
    if (path.includes('/dashboard')) return 'Dashboard'
    if (path.includes('/devices')) return 'Dispositivos'
    if (path.includes('/map') || path === '/home') return 'Mapa'
    return 'Mapa'
  }

  const changePage = (label) => {
    switch (label) {
      case 'Dashboard':
        navigate('/home/dashboard')
        break
      case 'Mapa':
        navigate('/home/map')
        break
      case 'Dispositivos':
        navigate('/home/devices')
        break
      default:
        navigate('/home')
    }
  }

  const updateTheme = () => {
    setTheme((theme) => (theme === "light" ? "dark" : "light"))
  }

  function logout() {
    localStorage.removeItem("user")
    navigate("/")
  }

  const activeLabel = getActiveLabel()

  return (
    <Container $isOpen={sideBarOpen}>
      <button className='sidebarButton' onClick={modSideBarOpen}>
        <AiOutlineLeft />
      </button>
      <div className='Logocontent'>
        <img src={logo} alt='Logo' />
      </div>
      {pagesArray.map(({ icon, label }, index) => (
        <button
          className={`pagesContainer ${activeLabel === label ? 'active' : ''}`}
          key={index}
          onClick={() => activeLabel === label ? '' : changePage(label)}
        >
          <div className='pagesIcon'>{icon}</div>
          {sideBarOpen && (<span>{label}</span>)}
        </button>
      ))}
      <button className='changeTheme' onClick={updateTheme}>
        <div className='pagesIcon'>
          {theme === 'light' ? <FaMoon /> : <FaSun />}
        </div>
        {sideBarOpen && (<span>Cambiar tema</span>)}
      </button>
      <button className='sign-out' onClick={logout}>
        <div className='pagesIcon'>
          <FaSignOutAlt />
        </div>
        {sideBarOpen && (<span>Cerrar sesion</span>)}
      </button>
    </Container>
  )
}

const pagesArray = [
  {
    label: "Dashboard",
    icon: <AiOutlineHome />,
  },
  {
    label: "Mapa",
    icon: <FaMapMarkedAlt />,
  },
  {
    label: "Dispositivos",
    icon: <BsFillDeviceSsdFill />,
  }
]

const Container = styled.div`
  z-index: 99;
  height: auto;
  background: #2858A2;
  color: #fff;
  position: sticky;
  padding-top: 20px;
  transition: all 0.3s;
  .sidebarButton {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: absolute;
    top: ${v.xxlSpacing};
    right: -18px;
    width: 32px;
    height: 32px;
    background: #2858A2;
    border-radius: 50%;
    color: #fff;
    border: none;
    transition: all 0.3s;
    transform: ${({ $isOpen }) => ($isOpen ? `initial` : `rotate(180deg)`)};
  }
  .Logocontent {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: ${v.xlSpacing};
    img {
      min-width: 60px;
      max-width: 40%;
      height: auto;
      transition: all .3s;
      ${/*transform: ${({ $isOpen }) => ($isOpen ? `scale(0.9)` : `scale(1.5)`)};*/""}
    }
  }
  .pagesContainer, .changeTheme, .sign-out {
    display: flex;
    width: 100%;
    height: 8%;
    align-items: center;
    text-decoration: none;
    border: none;
    background: #2858A2;
    color: #fff;
    padding: 0 15%;
    transition: all 0.3s;
    cursor: pointer;
    &.active {
      background: #265397;
    }
    .pagesIcon {
      padding: ${v.smSpacing} ${v.mdSpacing};
      display: flex;
      svg {
        font-size: 20px;
      }
    }
    span {
      font-size: 16px;
    }
  }
  .pagesContainer:hover, .changeTheme:hover, .sign-out:hover {
    background: #265397;
  }
  .changeTheme {
    display: none;
    position: absolute;
    bottom: 8vh;
    width: 100%;
  }
  .sign-out {
    position: absolute;
    bottom: 0px;
    width: 100%;
  }
`

export default Sidebar